import React from 'react';

function Header({ brand = 'HASEEB AHMED', links, action }) {
  return (
    <header className="site-header">
      <div className="container header-inner">
        <div className="brand-wrap">
          <div className="brand-mark">HA</div>
          <div className="brand-block">
            <div className="brand">{brand}</div>
            <div className="brand-subtitle">Executive Profile</div>
          </div>
        </div>
        <nav className="nav-links">
          {Array.isArray(links) && links.map((link) => (
            <a key={link.label} href={link.href}>{link.label}</a>
          ))}
          {action || null}
        </nav>
      </div>
    </header>
  );
}

export default Header;
